// Used in resource.component.html, singular-assignment.component.html, view-assignment.component.html, activity-preview-dialog.component.html, and composite-assignment-submit.component.html

// Angular
import {
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

// Services/Types/Helpers
import { CookieService } from "#services/cookie.service";
import { DevSpaceLoginResponse } from "cli-types";

// RXJS/Store
import { DevSpaceService } from "@carnegie-learning/data-access-angular-passport";
import { User } from "@carnegie-learning/data-access-fido";
import { Subject } from "rxjs";
import { first, takeUntil } from "rxjs/operators";

@Component({
    selector: "devspace-iframe",
    templateUrl: "./devspace-iframe.component.html",
    styleUrls: ["./devspace-iframe.component.scss"],
    standalone: false
})
export class DevspaceIframeComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject();

    iframeURL: SafeResourceUrl | null = null;
    loaded: boolean;
    showErrorMsg = false;

    @Input() fidoUser: User;

    constructor(
        private devSpaceService: DevSpaceService,
        private domSanitizer: DomSanitizer,
        private cookieService: CookieService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.loaded = false;
        this.loginDevSpaceUser();
    }

    loginDevSpaceUser() {
        this.devSpaceService
            .loginDevSpaceUser(this.fidoUser)
            .pipe(first(), takeUntil(this.ngUnsubscribe))
            .subscribe(
                (data: DevSpaceLoginResponse) => {
                    // set cookie for DevSpace Session
                    if (data.url !== "" && data.session !== "") {
                        // create a 30 day cookie
                        const d = new Date();
                        d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
                        const expires = "expires=" + d.toUTCString();
                        const domain = data.url.split("//")[1];
                        // try to set cookie for DevSpace Session
                        document.cookie =
                            "JSESSIONID" +
                            "=" +
                            data.session +
                            ";" +
                            expires +
                            ";path=/;domain=.emcl.com";
                        document.cookie =
                            "JSESSIONID" +
                            "=" +
                            data.session +
                            ";" +
                            expires +
                            ";path=/;domain=.qa-cli.com";
                        document.cookie =
                            "JSESSIONID" +
                            "=" +
                            data.session +
                            ";" +
                            expires +
                            ";path=/;domain=.carnegielearning.com";
                        document.cookie =
                            "JSESSIONID" +
                            "=" +
                            data.session +
                            ";" +
                            expires +
                            ";path=/;domain=." +
                            domain;

                        this.iframeURL =
                            this.domSanitizer.bypassSecurityTrustResourceUrl(
                                data.url
                            );
                        this.cdr.detectChanges();
                    }
                    this.showErrorMsg = false;
                    this.loaded = true;
                },
                (error) => {
                    this.showErrorMsg = true;
                    this.loaded = true;
                    this.cdr.detectChanges();
                }
            );
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next(true);
        this.ngUnsubscribe.complete();
    }
}
